const actions = {
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',

  LOG_PRODUCT_LIST:'LOG_PRODUCT_LIST',
  LOG_PRODUCT_LIST_RESULT:'LOG_PRODUCT_LIST_RESULT',
  LOG_PRODUCT_FETCH_ID:'LOG_PRODUCT_FETCH_ID',
  LOG_PRODUCT_FETCH_LIST_ID:'LOG_PRODUCT_FETCH_LIST_ID',
  LOG_PRODUCT_EDIT_BY_MGC:'LOG_PRODUCT_EDIT_BY_MGC',
  LOG_PRODUCT_NUT_EDIT_BY_ID: 'LOG_PRODUCT_NUT_EDIT_BY_ID',



  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),

  LogProductRead:(info)=>({
      type: actions.LOG_PRODUCT_LIST,
      payload:{info,page:1}
  }),
  onPageChange: (info, page) => ({
    type: actions.LOG_PRODUCT_LIST,
    payload: { info, page }
  }),
  LogProductListSuccess: (exportresult,result,success,total_count,passed_rows, fail_rows,page) => ({
   type: actions.LOG_PRODUCT_LIST_RESULT,
   exportresult,
   result,
   success,
   total_count,
   passed_rows,
   fail_rows,
   page
 }),
 LogProductfetchBYId:(listid)=>({
   type: actions.LOG_PRODUCT_FETCH_ID,
   payload:{listid}
 }),
 LogProductListById: (result,success) => ({
  type: actions.LOG_PRODUCT_FETCH_LIST_ID,
  result,
  success
}),
};
export default actions;
